import styled from 'styled-components';
import { shade } from 'polished';

export const Conteiner = styled.div`
  max-height: 800px;
  overflow-y: auto;
`;
